<template>
    <div class="validate-container">
        <h1>Оформление заказа</h1>
        <div class="validate-blocks">
            <GuestForm @revalidate="(data) => $emit('order', data)" @back="$emit('back')" @performInvoice="performInvoice" :shop="shop" :ordersum="validcart.amount" :canorder="validcart.canorder" @canOrder="e => $emit('validcart', {...validcart, canorder: e})" :api="api" :merchant_hash="merchant_hash"/>
            <div class="checkview">
                <h2>Ваш заказ</h2>
                <table class="check-data">
                    <tr> 
                        <td colspan="2"> Блюдо </td>
                        <td> Кол-во </td>
                        <td> Сумма </td>
                    </tr>
                </table>
                <div class="validate-table-scroller">
                    <table>
                        <tr v-for="(dish, index) of validcart.items" :key="index">
                            <td colspan="2"> 
                                <div>
                                    {{ dish.name }} 
                                </div>
                                <div v-for="modi in dish.modifiers" :key="modi.code" style="padding-left: 1em; font-size: .8em; opacity: .6">
                                    +{{modi.count}}x {{ modi.name }}
                                </div>

                            </td>
                            <td> {{ dish.quantity }} </td>
                            <td> ={{ ((dish.total + dish.discounted) / 100).toFixed(0) }}</td>
                        </tr>
                    </table>
                </div>
                <table class="check-data">
                    <tr v-if="validcart.discountsum">
                        <td colspan="3"> {{ validcart.discountsum > 0 ? 'Скидка' : 'Наценка'}} </td>
                        <td>  </td>
                        <td> {{ (validcart.discountsum * -1 / 100).toFixed(0) }}</td>
                    </tr>
                    <tr>
                        <td colspan="3"> Итого </td>
                        <td>  </td>
                        <td> {{ (validcart.amount / 100).toFixed(0) }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import GuestForm from './GuestForm'

export default {
    props:['validcart', 'cart', 'shop', 'api', 'merchant_hash'],
    methods:{
        performInvoice(guestData){
            guestData.autoinserted = []
            guestData.order.amount = this.validcart.amount
            guestData.order.content = this.validcart.items.filter( dish => {
                let cartPrototype = this.cart.find( item => {return item.code == dish.code} )
                if(!cartPrototype) {
                    //check for delivery dish. It is NOT autoinserted
                    if (this.validcart.delivery_dish) {
                        if (this.validcart.delivery_dish.code == dish.code) {
                            return true
                        }
                    }
                    guestData.autoinserted.push({
                        name: dish.name,
                        code: dish.code,
                        quantity: dish.quantity,
                        price: dish.price,
                        sum: dish.total,
                        total: dish.total
                    })
                    return false
                } else {return true}
            }).map( dish => {
                return {
                    name: dish.name,
                    code: dish.code,
                    modifiers: dish.modifiers,
                    quantity: dish.quantity,
                    price: dish.price,
                    total: dish.total
                }
            })
            
            this.$emit('performInvoice', guestData)
        },
        getOffsetSum(elem) {
            var top=0, left=0
            while(elem) {
                top = top + parseFloat(elem.offsetTop)
                left = left + parseFloat(elem.offsetLeft)
                elem = elem.offsetParent       
            }
            return {top: Math.round(top), left: Math.round(left)}
        }
    },    
    components:{
        GuestForm
    },
    mounted(){
        window.scrollTo({top: this.getOffsetSum(document.getElementById('minidelivery')).top})
    }
}
</script>